import type { FC } from "react";
import type { Dates } from "src/types/shared/cookies";
import { branch } from "src/website-apps/shared/components/branch";
import { withDefaultContexts } from "src/website-apps/shared/components/explore/withDefaultContexts";
import { withExploreContexts } from "src/website-apps/shared/components/explore/withExploreContexts";
import { withExploreExp } from "src/website-apps/shared/components/explore/withExploreExp";
import { VenueLayoutV2 } from "./VenueLayoutV2/VenueLayoutV2";

interface Props {
  dates?: Maybe<Dates>;
}

const UnwrappedApp: FC<Props> = ({ dates }) => <VenueLayoutV2 dates={dates} />;

const ExploreExpApp = branch(
  (props: Props & { exploreEnabled?: Maybe<boolean> }) => !!props.exploreEnabled,
  withExploreContexts,
  withDefaultContexts,
)(UnwrappedApp);
export const App = withExploreExp(ExploreExpApp);
